import { EditorAPIKey, EditorCoreApiKey } from '#packages/apis';
import { BaseEntryScope } from '#packages/apilib';

export class Scope extends BaseEntryScope {
  editorAPI = this.useDependency(EditorAPIKey);
  editorCoreAPI = this.useDependency(EditorCoreApiKey);
}
